import React from 'react';

interface RequiredLabelProps extends React.PropsWithChildren {
  required?: boolean;
}

export default function RequiredLabel({ required = false, children }: RequiredLabelProps) {
  if (!required) return children;

  return (
    <span>
      {children}
      <span className="leave-form-item-label-required">*</span>
    </span>
  );
}
